import { Button, Container, Typography, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline"; // Importing an error icon
import { motion } from "framer-motion"; // Adding animation

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container
      maxWidth="sm"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        textAlign: "center",
      }}
    >
      {/* Animated Icon */}
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <ErrorOutlineIcon
          sx={{
            fontSize: "4rem",
            color: "error.main",
            mb: 2,
          }}
        />
      </motion.div>

      {/* Animated Text */}
      <motion.div
        initial={{ y: -10, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        <Typography variant="h4" color="error" gutterBottom>
          Session Expired
        </Typography>
        <Typography variant="body1" gutterBottom>
          Your session has expired. Please log in again to continue.
        </Typography>
      </motion.div>

      {/* Animated Button */}
      <motion.div
        initial={{ y: 10, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.4 }}
      >
        <Box mt={2}>
          <Button
            variant="contained"
            color="primary"
            size="large"
            sx={{
              px: 4,
              py: 1,
              borderRadius: "8px",
              boxShadow: 2,
              transition: "all 0.3s ease-in-out",
              "&:hover": {
                boxShadow: 4,
                transform: "scale(1.05)",
              },
            }}
            onClick={() => navigate("/login")}
          >
            Go to Login
          </Button>
        </Box>
      </motion.div>
    </Container>
  );
};

export default NotFoundPage;
